import style from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';

export default function Comp() {
    const { t } = useLang('theProduct.EarlyBirdOffer');
    const { locale } = getLocal();
    return (
        <div
            className={`${style.comp} GtmModuleData-section`}
            id="EarlyBirdOffer"
            data-section-id="EarlyBirdOffer"
            data-section-title={t('title') || t('module-title')}
        >
            <EcoSpace />
            <div className="box">
                <div className="info">
                    <div className="title">{t('title')}</div>
                    <div className="desc">
                        {t.rich('desc', {
                            h: (v: string) => <span>{v}</span>,
                        })}
                    </div>
                </div>
                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1755488860998/EarlyBirdOffer.png" />
            </div>
        </div>
    );
}
